import { MaterialReactTable } from "material-react-table";
import { getImageUrl } from "utils/imageHelper";


export default function ProductCategoryTable({
  data = [],
  loading,
  onEdit,
  onDelete,
}) {
  const columns = [
    { accessorKey: "title", header: "Category Name" },
    {
      accessorKey: "image",
      header: "Image",
      Cell: ({ cell }) => {
        const value = cell.getValue();
        return value ? (
          <img
            src={getImageUrl(value)}
            alt="Category"
            className="h-12 w-12 rounded border object-cover"
          />
        ) : (
          "-"
        );
      },
    },
    {
      header: "Actions",
      Cell: ({ row }) => (
        <div className="flex gap-2">
          <button
            onClick={() => onEdit(row.original)}
            className="rounded bg-yellow-100 px-3 py-1 text-xs text-yellow-700"
          >
            Edit
          </button>
          <button
            onClick={() => {
              if (window.confirm(`Delete category "${row.original.title}"?`)) {
                onDelete(row.original);
              }
            }}
            className="rounded bg-red-100 px-3 py-1 text-xs text-red-700"
          >
            Delete
          </button>
        </div>
      ),
    },
  ];

  const flattenForExport = (rows, level = 0) => {
  let result = [];

  rows.forEach((row) => {
    const { children, ...rest } = row;

    result.push({
      ...rest,
      __level: level, // for indentation (optional)
    });

    if (children?.length) {
      result = result.concat(flattenForExport(children, level + 1));
    }
  });

  return result;
};


  const handleExportCsv = () => {
  const flatData = flattenForExport(data);

  const headers = columns
    .filter((c) => c.accessorKey)
    .map((c) => c.header);

  const rows = flatData.map((row) =>
    columns
      .filter((c) => c.accessorKey)
      .map((col) => {
        let value = row[col.accessorKey] ?? "";

        if (col.accessorKey === "title" && row.__level > 0) {
          value = `${"— ".repeat(row.__level)}${value}`;
        }

        return `"${String(value).replace(/"/g, '""')}"`;
      })
      .join(",")
  );

  const csvContent = "\uFEFF" + [headers.join(","), ...rows].join("\n");

  const blob = new Blob([csvContent], {
    type: "text/csv;charset=utf-8;",
  });

  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", "categories.csv");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};


  return (
    <>
      <div className="mb-3 flex justify-end">
        {/* <button
          onClick={handleExportCsv}
          className="rounded bg-green-500 px-3 py-1 text-xs text-white"
        >
          Export CSV
        </button> */}
      </div>

      <MaterialReactTable
        columns={columns}
        data={data}
        state={{ isLoading: loading }}
        enableExpanding
        getSubRows={(row) => row.children}
        muiTableBodyRowProps={{ hover: true }}
        enableGlobalFilter={false}
      />
    </>
  );
}